import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import _ from 'lodash'
import { groupElements } from '../../utils/helpers'
import Element from './Element'
import ElementGroup from './ElementGroup'

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: flex-start;
  width: 100%;
  background-color: ${props => props.theme.colors.white1};
`
// These are the rankings pulled from reportz db.
// We should add a priority prop to each
const reportzRanks = {
  Community: 30,
  Revenue: 54,
  'Category Management': 57,
  Customers: 60,
  Merchandising: 63,
  Traffic: 72,
  Conversion: 75,
  'Site Performance': 84,
  'Web Products': 111,
  Operations: 114,
  'Board Metrics': 120,
  'My Reportz Reports': 1000,
}

const topRanks = {
  'E-Comm Sales Meetings': 1,
  Wholesale: 2,
  Categories: 3,
  // 'Feature Engagement and Product': 2,
  Wedding: 4,
  'Baby And Kids': 5,
  Art: 6,
  Holiday: 7,
  Conversion: 8,
  Reportz: 9,
}

class ElementTree extends Component {
  getElements = elementsArray => {
    return _.sortBy(elementsArray, ['order_index']).map((element, index) => {
      return (
        <Element
          key={`${index} + ${element.uuid || element.name}`}
          source={element.source}
          history={this.props.history}
          elementId={element.uuid}
          selectedElementId={this.props.selectedElementId}
          name={element.name}
        />
      )
    })
  }

  // hard coded for reportz elements, refactor to make dynamic for all types and curated lists
  findSelectedAmongChildren = (elementId, children) => {
    const searchArrayForSelectedElement = arrayOfElements => {
      const match = _.find(arrayOfElements, {
        uuid: elementId,
      })
      return match
    }

    const searchObjectForSelectedElement = elementsObj => {
      if (Array.isArray(elementsObj)) {
        return searchArrayForSelectedElement(elementsObj)
      }
      let lookForElement = true
      const nodes = Object.values(elementsObj)
      let currentNode, elementFound
      while (lookForElement && nodes.length) {
        currentNode = nodes.shift()
        elementFound = searchObjectForSelectedElement(currentNode)
        lookForElement = elementFound ? false : lookForElement
      }
      return elementFound
    }

    return searchObjectForSelectedElement(children)
  }

  getChildren = (group, nest = 1) => {
    if (Array.isArray(group)) {
      return this.getElements(group)
    } else {
      return _.map(
        _.sortBy(_.toPairs(group), item => {
          return reportzRanks[item[0]] || 0
        }),
        ([groupName, group], index) => {
          return (
            <ElementGroup
              key={index + groupName}
              currentlySearching={this.props.currentlySearching}
              showChildren={this.findSelectedAmongChildren(this.props.selectedElementId, group)}
              name={groupName}
              nest={nest}
            >
              {this.getChildren(group, nest + 1)}
            </ElementGroup>
          )
        }
      )
    }
  }

  elementIsAmongChildren = group => {
    return (
      this.props.selectedElementId !== null &&
      this.findSelectedAmongChildren(this.props.selectedElementId, group)
    )
  }

  getGroups = ([groupName, group], index) => {
    return (
      <ElementGroup
        key={index + groupName}
        currentlySearching={this.props.currentlySearching}
        name={groupName}
        nest={0}
        showChildren={this.elementIsAmongChildren(group)}
      >
        {this.getChildren(group)}
      </ElementGroup>
    )
  }
  render() {
    const includeElement = (element, userEmail, currentElement) => {
      const currentElementParentId = currentElement ? currentElement.parent_id : null
      const currentElementId = currentElement ? currentElement.uuid : null
      return (
        element.owner_email === userEmail ||
        currentElementParentId === element.parent_id ||
        element.path
      )
    }
    const { userEmail, currentElement, elements } = this.props
    const showElements = elements.filter(element =>
      includeElement(element, userEmail, currentElement)
    )

    const pairs = _.toPairs(groupElements(showElements))
    const sortedPairs = _.sortBy(pairs, pair => topRanks[pair[0]])

    return <StyledDiv>{_.map(sortedPairs, this.getGroups)}</StyledDiv>
  }
}

function mapStateToProps(state, ownProps) {
  const { currentElement } = state.dataDirectory
  return {
    currentlySearching: state.dataDirectory.searchText.length > 0,
    elements: state.dataDirectory.filteredElements || [],
    userEmail: state.user.email,
    selectedElementId: currentElement ? currentElement.uuid : null,
    currentElement,
    ...ownProps,
  }
}

export default connect(mapStateToProps)(ElementTree)
